
import _throttle from 'lodash.throttle';
import { uploadEvents } from '../UploadEvents';
import { updateFile } from '../assets';
import { notify } from '../../../Notifications';
import {
  PROGRESS_THROTTLE,
  ITEM_STATUS,
  ASSET_STATUS,
  REMOVE_COMPLETED_DELAY } from
'../../constants';









class AssetUploadHandlers {


  _uploadedSize = 0;



  constructor(args) {
    this._args = args;
  }

  getHandlers() {
    return {
      error: this.getErrorHandler(this._args),
      progress: _throttle(this.getProgressHandler(this._args), PROGRESS_THROTTLE),
      complete: this.getCompletionHandler(this._args)
    };
  }

  getErrorHandler = (
  {
    totalSize,
    handleAssetUpdates,
    asset




  }) =>
  (currentUploaded) => {
    const alreadyErrored = this._isError;

    this._isError = true;

    const { assetId, filename } = asset;

    if (!currentUploaded) {
      handleAssetUpdates([{
        assetId,
        uploadStatus: ITEM_STATUS.ERROR
      }]);
    }

    this._uploadedSize = currentUploaded;

    const loadedPercent = Math.floor(this._uploadedSize / totalSize * 100);

    handleAssetUpdates([{
      assetId,
      uploadStatus: ITEM_STATUS.ERROR,
      loaded: this._uploadedSize,
      totalSize,
      loadedPercent: loadedPercent < 99 ? loadedPercent : 99
    }]);

    // Several parts can fail before a file is abandoned, so only the first
    // failure is announced.
    if (alreadyErrored) {return;}

    notify({
      content: `${filename || 'A file'} failed to upload. Retry or remove it before submitting.`,
      type: 'error'
    });
  };

  getProgressHandler = (
  {
    totalSize,
    asset



  }) =>
  (currentUploaded) => {
    if (this._isError) {return;}

    const { assetId } = asset;

    this._uploadedSize = currentUploaded;

    const loadedPercent = Math.floor(this._uploadedSize / totalSize * 100);

    uploadEvents.emit('progress', {
      assetId,
      loaded: this._uploadedSize,
      totalSize,
      loadedPercent: loadedPercent < 99 ? loadedPercent : 99
    });
  };

  getCompletionHandler = ({
    totalSize,
    handleAssetUpdates,
    asset,
    onUploadComplete,
    apiClient






  }) => async () => {
    const { assetFiles, organisationId } = asset;

    onUploadComplete();

    const updatedFile = await updateFile(apiClient, {
      organisationId,
      assetFileId: assetFiles.ORIGINAL.assetFileId,
      input: { status: ASSET_STATUS.UPLOADED }
    });

    if (!updatedFile) {return;}

    assetFiles.ORIGINAL = {
      ...assetFiles.ORIGINAL,
      ...updatedFile
    };

    handleAssetUpdates([{ ...asset, loadedPercent: 100, loaded: totalSize }]);

    setTimeout(() => {
      handleAssetUpdates([{ ...asset, uploadStatus: void 0 }]);
    }, REMOVE_COMPLETED_DELAY);
  };
}

export default AssetUploadHandlers;